<template>
  <v-btn
    flat
    color="accent"
    @click="accept"
    :loading="loading"
    :disabled="disabled"
  >{{ $t('message.common.publish') }}</v-btn>
</template>

<script>

export default {
  name: 'nx-live-messages-message-editor-dialog-buttons',
  props: {
    loading: Boolean,
    disabled: Boolean,
    messageThatIsBeingEdited: Object,
  },
  methods: {
    accept() {
      this.$emit('accept');
    },
  },
};
</script>
